// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const AuditResultModalHeader = props =>
    <header>
        <span>
            <FormattedMessage id='AUDIT_RESULTS'/>
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

AuditResultModalHeader.displayName = 'AuditResultModalHeader';
AuditResultModalHeader.propTypes = {
    onCloseButtonClick: PropTypes.func.isRequired
};

export default AuditResultModalHeader;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-result-modal/audit-result-modal-header.js